module.exports = __webpack_public_path__ + "static/ebr-8-913508b839e0b814373c6ca3d53abc3b.jpg";